// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__xlCzB","container":"style_container__1rLe8","field":"style_field__1tJGz","checkbox":"style_checkbox__1nDRF","buttons":"style_buttons__2_JNi"};